export default "__VITE_ASSET__0510e903__"